module.exports = __webpack_public_path__ + "img/planQRLogo.985b926c.png";